import { Route, Switch } from 'react-router';

import useCurrentPath from 'common/hooks/useCurrentPath';

import { FiltersProvider } from './hooks/useFilters';
import CatalogList from './pages/List';

const Catalog = () => {
  const { path } = useCurrentPath();

  return (
    <Switch>
      <Route exact path={path}>
        <FiltersProvider>
          <CatalogList />
        </FiltersProvider>
      </Route>
    </Switch>
  );
};

export default Catalog;
